<template>
    <section class="content" ref="pd">
        <div class="row">
            <div class="col-md-12">
                <reels-form :reel="reel" @search="search(reel)"
                            :showLabels="false" :showSearch="true"></reels-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <reels-tab v-bind="{requestFunction}" ref="reelsRef" id="reelsId"/>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import reelsForm from './Form.vue'
  import reelsApi from '../../api/reels'
  import Reel from '../../models/reel'
  import reelsTab from '../components/ReelsTab'

  export default {
    components: {
      reelsForm,
      reelsTab
    },

    data () {
      return {
        reel: new Reel(false, undefined),
        firstAccess: true
      }
    },

    mounted () {
      window.addEventListener('keypress', e => {
        if (e.keyCode === 13) {
          this.$refs.reelsRef.refresh()
          setTimeout(() => { this.$scrollTo('#reelsId') }, 100)
        }
      })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Cerca bobine',
        createButton: {display: false}
      })
      this.$emit('addBackgroundColor', 'rgb(202,94,66)')
    },

    methods: {
      search () {
        this.$refs.reelsRef.refresh()
        this.$scrollTo('#reelsId')
      },
      showReel (id) {
        this.$router.push({name: 'reelsShow', params: {id: id}})
      },
      requestFunction: function (query) {
        if (!this.firstAccess) {
          return reelsApi.search(this.reel, query)
        }
        this.firstAccess = false
        return reelsApi.search({'id': 111111}, query)
      }
    }
  }
</script>

<style>
    tr {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/reels/Search.vue